import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterreportingToolViewComponent } from './masterreporting-tool-view.component';

import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MasterreportingToolViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule
  ],
  exports: [
    MasterreportingToolViewComponent
  ]
})
export class MasterreportingToolViewModule { }
